import { render, staticRenderFns } from "./leftCent.vue?vue&type=template&id=2ea14dda&scoped=true"
import script from "./leftCent.vue?vue&type=script&lang=js"
export * from "./leftCent.vue?vue&type=script&lang=js"
import style0 from "./leftCent.vue?vue&type=style&index=0&id=2ea14dda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea14dda",
  null
  
)

export default component.exports